/*
 * @Author: zxf
 * @Date: 2021-11-16 18:56:56
 * @LastEditors: zhangqi
 * @LastEditTime: 2025-04-15 11:26:01
 * @Description: file content
 * @FilePath: \neolix-map-sdk\src\algorithm\geometry.js
 */
import * as THREE from "../../libs/three.js/build/three.module.js";
import Singleton from './../clazz/Singleton'

export class GemmetryAlgorithm extends Singleton {
    constructor() {
        super();
    }


    /**
     * @Author: zxf
     * @description: 普通坐标点转化为geojson
     * @param {*} vectors
     * @param {*} type
     * @return {*}
     */
    vectorsToGeoJson(vectors, type) {
        switch (type) {
            case 'LineString':
                return this.vectorsToLineString(vectors);
                break;
            case 'Polygon':
                return this.vectorsToPolygon(vectors);
                break;
            case 'Point':
                return this.vectorsToPoint(vectors);
                break;
            default:
                break;
        }
    }

    vectorsToLineString(vectors) {
        const coordinates = [];
        for (let i = 0; i < vectors.length; i++) {
            coordinates.push([vectors[i].x, vectors[i].y, vectors[i].z]);
        }
        return {
            coordinates: coordinates,
            type: 'LineString'
        }
    }

    vectorsToPolygon(vectors) {
        const coordinates = [];
        for (let i = 0; i < vectors.length; i++) {
            coordinates.push([vectors[i].x, vectors[i].y, vectors[i].z]);
        }
        return {
            coordinates: [coordinates],
            type: 'Polygon'
        }
    }

    vectorsToPoint(vectors) {
        return {
            coordinates: [vectors.x, vectors.y, vectors.z],
            type: 'Point'
        }
    }

    getVerticalPoint() {

    }

    getAngleBetweenLines(cornerPoint, point1, point2) {
        let v1 = new THREE.Vector3().subVectors(point1.position, cornerPoint.position);
        let v2 = new THREE.Vector3().subVectors(point2.position, cornerPoint.position);

        // avoid the error printed by threejs if denominator is 0
        const denominator = Math.sqrt(v1.lengthSq() * v2.lengthSq());
        if (denominator === 0) {
            return 0;
        } else {
            return v1.angleTo(v2);
        }
    };

    getDistancePointToLine(pt1, pt2, pt) {
        const egdeV1 = new THREE.Vector3().subVectors(pt2, pt1)
        const egdeV2 = new THREE.Vector3().subVectors(pt, pt1)

        // translate to normalize
        const v1Norm = egdeV1.clone().normalize()
        const v2Norm = egdeV2.clone().normalize()
        // calculate the cos@ between vector 1 and vector 2
        const cos1 = v1Norm.dot(v2Norm)

        const egdeV3 = new THREE.Vector3().subVectors(pt, pt2)
        const egdeV4 = new THREE.Vector3().subVectors(pt1, pt2)
        const v3Norm = egdeV3.clone().normalize()
        const v4Norm = egdeV4.clone().normalize()
        // calculate the cos@ between vector 1 and vector 2
        const cos2 = v3Norm.dot(v4Norm)

        // make sure to angel are less than 90, the distance will be located at red line
        if (cos2 > 0 && cos1 > 0) {

            const sin = Math.sqrt(1 - cos1 * cos1)

            const yDistance = pt1.distanceTo(pt)
            const distance = yDistance * sin

            // calculate target point
            const xDistance = yDistance * cos1
            const dir = egdeV1.clone().normalize().multiplyScalar(xDistance)
            const targetPt = pt1.clone().add(dir)

            return { 'pt1': pt1, 'pt2': pt2, 'pt': pt, 'distance': distance, 'targetPt': targetPt }
        }

        return null
    }

    getDistancePointToLines(pt, line) {
        let mindistance = 10000;
        let index = 0;
        let nextIndex = 1;
        let targetPt = null;
        for (let i = 0; i < line.length - 1; i++) {
            let currPoint = new THREE.Vector3(line[i][0], line[i][1], line[i][2]);
            let nextPoint = new THREE.Vector3(line[i + 1][0], line[i + 1][1], line[i + 1][2]);
            let distanceInfo = this.getDistancePointToLine(currPoint, nextPoint, pt);
            if (distanceInfo && distanceInfo.distance < mindistance) {
                mindistance = distanceInfo.distance;
                index = i;
                nextIndex = i + 1;
                targetPt = distanceInfo.targetPt;
            }
        }
        if (mindistance < 10000) {
            return {
                distance: mindistance,
                index: index,
                nextIndex: nextIndex,
                targetPt: targetPt
            }
        }
        return null;
    }

    /**
     * @Author: zxf
     * @description: 获取两点之间的距离
     * @param {*}
     * @return {*}
     */
    getV2PointDistance(p1, p2) {
        const dx = Math.abs(p2.x - p1.x);
        const dy = Math.abs(p2.y - p1.y);
        const dis = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
        return dis;
    }

    /**
     * @Author: zxf
     * @description: 获取到线段最近点
     * @param {*} line
     * @param {*} point
     * @return {*}
     */
    getNearPointToLine(pt1, pt2, point) {
        const dx = pt2.x - pt1.x;
        const dy = pt2.y - pt1.y;
        let x, y;
        if (dx === 0 && dy === 0) {
            // pt1 和 pt2 是同一点，返回该点
            x = pt1.x;
            y = pt1.y;
        } else if(dx === 0) {
            // 垂直线的情况
            x = pt1.x;
            y = point.y;
        } else {
            // 非垂直线的情况(水平线可通用)
            const k = dy / dx;
            x = (k * k * pt1.x + k * (point.y - pt1.y) + point.x) / (k * k + 1);
            y = k * (x - pt1.x) + pt1.y;
        }
        const resPoint = { x: x, y: y };
        const maxY = Math.max(pt2.y,pt1.y);
        const minY = Math.min(pt2.y,pt1.y);
        const maxX = Math.max(pt2.x,pt1.x);
        const minX = Math.min(pt2.x,pt1.x);
        if(y <= maxY && y >= minY && x <= maxX && x >= minX) {
            return { point: resPoint, distance: this.getV2PointDistance(point, resPoint) };
        } else if(this.getV2PointDistance(point, pt1) < this.getV2PointDistance(point, pt2)) {
            return { point: pt1, distance: this.getV2PointDistance(point, pt1)};
        } else {
            return { point: pt2, distance: this.getV2PointDistance(point, pt2)};
        }
    }

    /**
     * @Author: zxf
     * @description: 获取到多线段最近点
     * @param {*} lines
     * @param {*} point
     * @return {*}
     */
    getNearPointToLines(lines, point) {
        let res = { point: null, distance: 10000000 };
        let preIndex = 0;
        let nextIndex = 0;
        for (let i = 0; i < lines.length - 1; i++) {
            let pt1 = { x:lines[i][0], y: lines[i][1] };
            let pt2 = { x:lines[i + 1][0], y: lines[i + 1][1] };
            const nearPoint = this.getNearPointToLine(pt1, pt2, point);
            if(res.distance > nearPoint.distance) {
                preIndex = i;
                nextIndex = i + 1;
                res = nearPoint;
            }
        }
        res.preIndex = preIndex;
        res.nextIndex = nextIndex;
        return res;
    }


    getV3PointByV2Point(centerV2Point, preV2Point, nextV2Point, preV3Point, nextV3Point) {
        const v2Distance = this.getV2PointDistance(preV2Point, nextV2Point);
        const v2ResDistance = this.getV2PointDistance(preV2Point, centerV2Point);
        const precent = v2Distance/v2ResDistance;
        const x = nextV3Point.x + ((preV3Point.x - nextV3Point.x) * precent);
        const y = nextV3Point.y + ((preV3Point.y - nextV3Point.y) * precent);
        const z = nextV3Point.z && preV3Point.z ? nextV3Point.z + ((preV3Point.z - nextV3Point.z) * precent) : 0;
        return { x: x, y: y, z: z };
    }
}